export enum WorkspaceQueryKey {
  GET_WORKSPACE = 'GET_WORKSPACE'
}
